import './mini-cart'
import './shared-cart'
import './single-product'
import './hedge-calculator'
import './pricing-tiers'
// Efter pricing-tiers: den binder sin found_variation-handler först och skriver
// trapp-priset deferrat, så den vinner över basprisét som fylls in här.
import './variation-price'
// Efter variation-price: den skriver in styckpris-spanen, unit-price läser om
// utgångsläget och lägger på rätt trappsteg.
import './unit-price'
import './product-total'
import './loop-products'
import './hover-image'
import './latest-products'
import './woo-filters'
import './category-accordion'
import './archive-term-description'
import './checkout'
import './checkout-coupon'
import './checkout-order-notes'
import './product-facts'
import './variation-gallery'
import './variation-dropdown'
import './out-of-stock'

// jQuery(document.body).on(
//     [
//         // Add to cart / cart
//         'adding_to_cart',
//         'added_to_cart',
//         'wc_cart_button_updated',
//         'removed_from_cart',
//         'wc_cart_emptied',
//         'wc_fragment_refresh',
//         'wc_fragments_refreshed',
//         'wc_fragments_loaded',
//         'cart_page_refreshed',
//         'updated_wc_div',

//         // Mini cart / fragments
//         'wc_fragments_loaded',
//         'wc_fragments_refreshed',

//         // Checkout lifecycle
//         'init_checkout',
//         'update_checkout',
//         'updated_checkout',
//         'checkout_error',
//         'reset_data',

//         // Cart totals / shipping
//         'updated_cart_totals',
//         'cart_totals_refreshed',
//         'updated_shipping_method',
//         'country_to_state_changed',

//         // Coupons
//         'applied_coupon',
//         'removed_coupon',
//         'applied_coupon_in_checkout',
//         'removed_coupon_in_checkout',

//         // Payments
//         'payment_method_selected',
//         'init_add_payment_method',

//         // Variations
//         'found_variation',
//         'reset_variations',
//         'hide_variation',
//         'show_variation',

//         // Misc / legacy
//         'updated_checkout',
//         'updated_cart_totals',
//     ].join(' '),
//     function (e, data) {
//         console.log('[WC EVENT]', e.type, data || null)
//     }
// )
